import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getChatAnimationCounter, getAnimationShownCount, getPrevPathCookie } from '../utils/chatAnimationCounter';
import {
  incrementAnimationCounter,
  setAnimationCounter,
  setAnimationShownCount,
} from '../../../actions/consultantCianChat';
import { animationCounterSelector, animationShownCountSelector } from '../../../selectors/consultantCianChat';
import { TTypedThunkDispatch } from '../../../types/thunk';
import { animationDelayMsSelector } from '../../../selectors/consultantCianChat/animationDelayMsSelector';

export const useChatAnimationCounter = () => {
  const dispatch = useDispatch<TTypedThunkDispatch>();
  const counter = useSelector(animationCounterSelector);
  const animationShownCount = useSelector(animationShownCountSelector);
  const animationDelayMs = useSelector(animationDelayMsSelector);

  const [shouldShowAnimation, setShouldShowAnimation] = React.useState(false);

  React.useEffect(() => {
    const cookieCounter = getChatAnimationCounter();
    const cookieAnimationShownCount = getAnimationShownCount();
    dispatch(setAnimationCounter(cookieCounter));
    dispatch(setAnimationShownCount(cookieAnimationShownCount));
    const currentPath = window.location.pathname + window.location.search;
    const prevPath = getPrevPathCookie();

    if (prevPath !== currentPath) {
      dispatch(incrementAnimationCounter());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!animationShownCount || counter - animationShownCount >= 5) {
      setShouldShowAnimation(true);
    } else {
      setShouldShowAnimation(false);
    }
  }, [counter, animationShownCount, dispatch]);

  const incrementAnimationShownCounter = React.useCallback(() => {
    dispatch(setAnimationShownCount(counter));
  }, [counter, dispatch]);

  return { counter, shouldShowAnimation, incrementAnimationCounter, animationDelayMs, incrementAnimationShownCounter };
};
